import { PostBeconLog, PostReportToSlack } from "@becon-team/becon-fe-lib/services";
import axios from "axios";
import { axiosInstance } from "libs/axiosInstance";

/** POST: 로그 기록 (query X, 기본 axiosInstance) */
export const postBeconLog: PostBeconLog = async (body) => {
  const serverRes = await axios
    .create({
      baseURL: process.env.REACT_APP_SALON_BASE_URL,
    })
    .post(`/device-log`, body);

  return serverRes.data;
};

/** POST: 에러 리포트 슬랙 전송 (query X)TODO: 서버 열어달라고 요청 필요  */
export const postReportToSlack: PostReportToSlack = async ({ message }) => {
  // 인증 수단이 없는 경우 전송 방지
  const defaultHeaders = axiosInstance.defaults.headers.common;
  const hasCookie = defaultHeaders["Cookie"] || defaultHeaders["cookie"];
  const hasAuthorization = defaultHeaders["Authorization"] || defaultHeaders["authorization"];
  if (!hasCookie && !hasAuthorization) {
    return;
  }

  const serverRes = await axiosInstance.post(
    `/report`,
    { message },
    {
      baseURL: process.env.REACT_APP_SALON_BASE_URL,
    },
  );

  return serverRes.data;
};
